// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helper from '../../helper/Helper';

class LocaleLink extends Component {
    render() {
        const props = { ...this.props };
        if (props.target && props.target === '_self' && !props.onClick) {
            props.onClick = function(e) {
                e.preventDefault();
                window.open(props.to, '_self');
            };
        }
        return (
            <Link
                onClick={props.onClick}
                className={props.className}
                style={props.style}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                to={
                    props.target && props.target === '_self'
                        ? props.to
                        : `/${Helper.getLocale()}` + props.to
                }
            >
                {props.children}
            </Link>
        );
    }
}
LocaleLink.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    target: PropTypes.string,
    locale: PropTypes.string,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
};
const mapStateToProps = state => {
    return {
        lang: state.locale.lang,
    };
};
export default connect(mapStateToProps)(LocaleLink);



// WEBPACK FOOTER //
// ./src/components/common/LocaleLink.js